import React from 'react';
import Button from '@atlaskit/button';
import { analytics, createRedirectEvent } from '@atlassian/temp-analytics';
import { ufoCommonButtonClickEvents } from '@atlassian/temp-observability';
import { useApplicationContext } from '../../common-context';

interface Props {
  href: string;
  label?: string;
}

const AdaRedirectButton = ({ href, label }: Props) => {
  //generalized way of capturing all the button click event on ADA Redirect button
  const context = useApplicationContext();
  const product = context.product?.toLowerCase();
  const pageName = window.location.pathname.split('/')[1];
  const buttonName = label || 'View in ADA';
  return (
    <Button
      target="_blank"
      href={href}
      testId="ada-redirect-btn"
      onClick={() => {
        analytics.sendUIEvent(createRedirectEvent(buttonName));
        ufoCommonButtonClickEvents(product, pageName, buttonName);
      }}
    >
      {label || `View in ADA`}
    </Button>
  );
};

export default AdaRedirectButton;
